import Helper from './Helper';
import HeroVideo from './HeroVideo';


class Tabs {
  constructor(config = {}) {
    const {} = config;
    const tabContainerSelector = '.ns-tab-container';
    this.tabSelector = '.ns-tab';
    this.tabTitleSelector = '.ns-tab__title';
    this.tabNavSelector = '.ns-tab-container__nav';
    this.breakpointMd = 1024;
    const tabs = [...document.querySelectorAll(tabContainerSelector)];
    this.content = document.querySelector('.content');
    if (tabs.length > 0) {
      tabs.forEach(tabContainer => {
        this.buildHTML(tabContainer);
      });
    }
  }

  buildHTML(tabContainer) {
    const titles = [...tabContainer.querySelectorAll(this.tabTitleSelector)];
    const tabs = [...tabContainer.querySelectorAll(this.tabSelector)];
    titles.forEach((title, i) => {
      const toggle = document.createElement('div');
      toggle.classList.add('ns-tab-container__toggle');
      toggle.innerHTML = title.innerText;
      tabContainer.querySelector(this.tabNavSelector).appendChild(toggle);
    });
    const toggles = [...tabContainer.querySelectorAll('.ns-tab-container__toggle')];
    this.registerToggles(toggles, tabs);
    this.setTabToActive(toggles, tabs, 0);

    const vw = window.innerWidth;
    if (vw < this.breakpointMd) {
      this.mobileTabInteration(tabs);
    }

    window.addEventListener('resize', () => {
      const vw = window.innerWidth;
      if (vw < this.breakpointMd) {
        this.mobileTabInteration(tabs);
      }
    });
  }

  registerToggles(toggles, tabs) {
    toggles.forEach((toggle, i) => {
      toggle.addEventListener('click', e => {
        this.setTabToActive(toggles, tabs, i);
      });
    });
  }

  setTabToActive(toggles, tabs, index) {
    toggles.forEach((toggle, i) => {
      if (i == index) {
        toggle.classList.add('active');
      } else {
        toggle.classList.remove('active');
      }
    });
    tabs.forEach((tab, i) => {
      if (i == index) {
        tab.classList.add('active');
        Helper.slideOpen(tab, true);
      } else {
        tab.classList.remove('active');
        Helper.slideClose(tab);
      }
    });
    const currentlyActive = document.querySelector('.ns-tab.active');
    const hero = currentlyActive.closest('.ns-hero-section');

    new HeroVideo({heroObject: hero, tabObject: currentlyActive, mobileImgSelector: '.ns-tab__mobile-img', videoSelector: '.ns-tab__video'});

    for (let i = hero.classList.length - 1; i >= 0; i--) {
      const className = hero.classList[i];
      if (className.startsWith('ns-tab-gradient')) {
        hero.classList.remove(className);
      }
    }

    for(let i = currentlyActive.classList.length - 1; i >= 0; i--){
      const className = currentlyActive.classList[i];
      if(className.startsWith('gradient')){
        hero.classList.add('ns-tab-'+className);
      }
    }
  }

  mobileTabInteration(tabs) {
    tabs.forEach((tab, i) => {
      let hero = tab.closest('.ns-hero-section');
      let removeImages = true;
      if ( i > 0 ) {
        removeImages = false;
      }

      new HeroVideo({heroObject: hero, tabObject: tab, mobileImgSelector: '.ns-tab__mobile-img', videoSelector: '.ns-tab__video', removeImages: removeImages});
    });
  }
}

export default Tabs;
